var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"CircleIconButton",class:{ 'CircleIconButton--disabled': _vm.disabled},attrs:{"disabled":_vm.disabled},on:{"click":_vm.buttonClicked}},[_c('span',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }